import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TurnstileService {
  private customHeaderValue$: BehaviorSubject<string> = new BehaviorSubject('');
  private reset$: Subject<boolean> = new Subject();

  setCustomHeader(value: string): void {
    this.customHeaderValue$.next(value);
  }

  getCustomHeaderObs(): Observable<string> {
    return this.customHeaderValue$.asObservable();
  }

  getCustomHeader(): string {
    return this.customHeaderValue$.value;
  }

  onReset(): void {
    this.reset$.next(true);
  }

  resetChange(): Observable<boolean> {
    return this.reset$.asObservable();
  }
}
